import { action } from 'satcheljs';

export let showOfficeAppCard = action('SHOW_OFFICE_APP_CARD');
